import React, { useMemo, useState } from 'react';
import { SchemaEmail } from '@axiom/types';

import type { LoginContextType } from './LoginContext';
import { LoginContext, InitialLoginState } from './LoginContext';

export type LoginContextProviderProps = {
  children: React.ReactNode;
  name?: string;
};

export const isInvalidMfaState = (
  loginState: LoginContextType['loginState']
) => {
  return (
    !loginState.email ||
    !SchemaEmail.safeParse(loginState.email).success ||
    !loginState.password
  );
};

export const LoginContextProvider = ({
  children,
  name = 'LOGIN_CONTEXT_PROVIDER',
}: LoginContextProviderProps) => {
  const [loginState, setLoginState] = useState(InitialLoginState);
  const providerValue = useMemo(
    () => ({
      loginState,
      setLoginState,
      isInvalidMfaState: isInvalidMfaState(loginState),
    }),
    [loginState]
  );

  return (
    <div data-test={name}>
      <LoginContext.Provider value={providerValue}>
        {children}
      </LoginContext.Provider>
    </div>
  );
};
